
/* eslint-disable */
import Bi5FirebaseAuth from './watchdog_includes/base_i5_firebase_auth'
import bi7WebGuiData from './watchdog_includes/base_i7_web_gui_data'
import bi11WebSocket from './watchdog_includes/base_i11_web_socket.js'
import Bi8VueDataConnector from './watchdog_includes/base_i8_vue_data_connectors'
import Bi9CssLoader from './watchdog_includes/base_i9_branding_css'

// produtction versus dev stuff
window.G_dev_live_flag_force = 0;
window.G_ajax_test_domain = '';
window.G_p1s6_tasks_domain = "https://gui.dgnet.cloud";
window.G_p1s10t1_socket_domain = "wss://gui.dgnet.cloud";
window.G_watchdog_auth_domain = 'https://watchdog.dgnet.cloud'
window.G_dev_flag = 0;

if (window.location.hostname.toString().includes('dev') ||
    window.location.hostname.toString().includes('localhost') || 
    window.location.hostname.toString().includes('127.0.0.1')) 
  {
    window.G_dev_flag = 1;
    window.G_ajax_test_domain = 'https://dev-gui.dgnet.cloud';
    window.G_p1s6_tasks_domain = "https://dev-gui.dgnet.cloud";
    window.G_watchdog_auth_domain = 'https://dev-watchdog.dgnet.cloud'
    window.G_p1s10t1_socket_domain = "wss://dev-gui.dgnet.cloud";
  }

  //forcing live flag should only work on localhost
  if ((window.location.hostname.toString().includes('localhost') || 
      window.location.hostname.toString().includes('127.0.0.1')) && 
      (window.G_dev_live_flag_force === 1))
    {
      window.G_dev_flag = 0;
      window.G_ajax_test_domain = 'https://gui.dgnet.cloud';
      window.G_p1s6_tasks_domain = "https://gui.dgnet.cloud";
      window.G_watchdog_auth_domain = 'https://watchdog.dgnet.cloud';
      window.G_p1s10t1_socket_domain = "wss://gui.dgnet.cloud";

  }

window.less = {
  env: 'development',
  logLevel: 2,
  async: false,
  fileAsync: false,
  poll: 2000,
  functions: {},
  dumpLineNumbers: 'comments',
  relativeUrls: false,
  globalVars: {
    var1: '"quoted value"',
    var2: 'regular value'
  },
  rootpath: ':/localhost/'
}

Bi8VueDataConnector.bi8LocalStorageVersionCheck('2020-07-02:08:03')
// load the branding based off the domain
Bi9CssLoader.bi9LoadSiteCssFile()
Bi9CssLoader.bi9LoadSiteTitle()
Bi9CssLoader.bi9LoadSiteIcon()
window.G_brand_id = Bi9CssLoader.getBrandId()
window.G_brand_color = Bi9CssLoader.getBrandColor()
window.G_redirectUrl = null
window.G_less_include = require('less')
window.G_firebase_auth = new Bi5FirebaseAuth()
window.G_firebase_auth.setSignedInGlobalCallback(Bi8VueDataConnector.bi8SignInCallback)
window.G_firebase_auth.setSignedOutGlobalCallback(Bi8VueDataConnector.bi8SignOutCallback)
window.G_firebase_auth.bi5SetTokenUpdatedCallback(Bi8VueDataConnector.bi8FirebaseTokenUpdatedCallback)
window.G_username = ''
window.G_ip = ''
window.G_page_id = ''
window.G_web_gui_data = new bi7WebGuiData()
window.G_web_socket = new bi11WebSocket()
window.G_web_gui_data.bi7setDataChangedCallback('IV_user_info', Bi8VueDataConnector.bi8SetVueUserInfoSuccess)



// WEBPACK FOOTER //
// ./src/run_first.js